import { useMemo } from 'react';

interface UseStructuredDataProps {
  pageType: string;
  entityData?: any;
  pageData?: any;
}

export const useStructuredData = ({ pageType, entityData }: UseStructuredDataProps) => {
  return useMemo(() => {
    const baseUrl = 'https://psychotherapist.help';
    
    const commonData = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Global Therapy Connect",
      "url": baseUrl
    };

    switch (pageType) {
      case 'city':
        if (entityData) {
          return [{
            ...commonData,
            "@type": "LocalBusiness",
            "name": `Mental Health Services in ${entityData.name}`,
            "address": {
              "@type": "PostalAddress",
              "addressLocality": entityData.name,
              "addressCountry": entityData.country
            }
          }];
        }
        break;
      case 'home':
        return [{
          ...commonData,
          "@type": "WebSite",
          "potentialAction": {
            "@type": "SearchAction",
            "target": `${baseUrl}/find?q={search_term_string}`,
            "query-input": "required name=search_term_string"
          }
        }];
      default:
        return [commonData];
    }
    
    return [commonData];
  }, [pageType, entityData]);
};